'use es6';

export const ENABLED = ['enabled'];